import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { Subscription } from './types/Subscriptions';

export default (makeCall: MakeCall) => (subId: string | number) =>
  makeCall<Subscription>(
    'POST',
    `${APIV2_URL}/billing/subscription/${subId}/reactivate`,
  );
